unit unit_Passwortanforderung;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client, WEBLib.Grids, DB;

type
  TPasswortanforderung = class(TForm)
    xdsAnmeldung: TXDataWebDataSet;
    xdsAnmeldungKundennummer: TStringField;
    xdsAnmeldungLoginPW: TStringField;
    xdsAnmeldungNachname: TStringField;
    xdsAnmeldungVorname: TStringField;
    xdsAnmeldungEMail: TStringField;
    WClient: TXDataWebClient;
    TC: TTableControl;
    xdsAnmeldungLoginAktiv: TIntegerField;
    xdsProtokoll: TXDataWebDataSet;
    xdsProtokollID: TIntegerField;
    xdsProtokollDatum: TDateTimeField;
    xdsProtokollKundennummer: TStringField;
    xdsProtokollNotiz: TStringField;
    xdsProtokollPruefungErforderlich: TBooleanField;
    xdsProtokollPruefungErledigt: TDateTimeField;
    xdsProtokollPruefungErledigtDurch: TStringField;
    xdsProtokollBemerkung: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsAnmeldungAfterOpen(DataSet: TDataSet);
    procedure xdsProtokollAfterOpen(DataSet: TDataSet);
    procedure xdsProtokollAfterPost(DataSet: TDataSet);
    procedure xdsProtokollAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }

    btnAnfordern:TButton;
    buttonzurueck:TButton;
    procedure btnAnfordernclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  Passwortanforderung: TPasswortanforderung;
  edtKundennummer:TEdit;

implementation
  uses unit1, unit2;
{$R *.dfm}
procedure TPasswortanforderung.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TPasswortanforderung.btnAnfordernclick(Sender:TObject);
begin
  if edtKundennummer.text='' then
  begin
    showmessage('Sie müssen Ihre Kundennummer eingeben');
    edtKundennummer.SetFocus;
    exit;
  end;
  KundeKundennummer:=edtKundennummer.text;

  xdsAnmeldung.Close;
  xdsAnmeldung.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsAnmeldung.Load;
end;

procedure TPasswortanforderung.WebFormShow(Sender: TObject);
begin
  xdsProtokoll.Load;
end;

procedure TPasswortanforderung.xdsAnmeldungAfterOpen(DataSet: TDataSet);
  procedure OnResponse(Response:TXDataClientResponse);
  var
    myresult:string;
  begin
    myresult:=string(TJSObject(response.Result)['value']);
    if myresult='OK' then
    begin
      showmessage('Ein Aktivierungslink wurde an Sie verschickt');
      xdsProtokoll.Append;
      xdsProtokollDatum.AsDateTime:=date+time;
      xdsProtokollKundennummer.AsString:=xdsAnmeldungKundennummer.AsString;
      xdsProtokollNotiz.AsString:='Passwortanforderung '+InternetIpAdresse;
      xdsProtokoll.Post;
    end
    else
    begin
      showmessage('Es konnte kein Aktivierungslink erstellt werden');
    end;
  end;
begin
  if xdsAnmeldung.RecordCount<>1 then
  begin
    showmessage('Kundennummer ist nicht gültig, Ihre Anforderung kann nicht verarbeitet werden.');
    xdsAnmeldung.Close;
    exit;
  end;
  if xdsAnmeldung.RecordCount=1 then
  begin
    if xdsAnmeldungLoginAktiv.AsInteger=1 then
    begin
      WClient.RawInvoke('IServerService.PasswortVergessen',[xdsAnmeldungKundennummer.AsString],@OnResponse);
    end
    else
    begin
      showmessage('Kundennummer ist nicht zugelassen, Ihre Anforderung kann nicht verarbeitet werden.');
    end;

  end;
end;

procedure TPasswortanforderung.xdsProtokollAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error) else close;
  end;

end;

procedure TPasswortanforderung.xdsProtokollAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  TC.ColCount:=1;
  TC.RowCount:=6;
  tc.cells[0,i]:='<h2>Passwort-Anforderung';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;
  inc(i);
  tc.Cells[0,i]:='<h6>Hier können Sie Ihr Passwort zurücksetzen lassen.<br>Wir senden Ihnen dann einen Aktivierungslink an die bei uns hinterlegte Emailadresse, mit dem Sie ein neues Passwort vergeben können.';
  inc(i);
  tc.Cells[0,i]:='Ihre Kundennummer: <br>';
  myelement:=TC.CellElements[0,i];
  edtKundennummer:=TEdit.Create(self);
  edtKundennummer.ElementClassName:='form-control';
  edtKundennummer.Width:=200;
  edtKundennummer.HeightStyle:=ssAuto;
  edtKundennummer.TextHint:='';
  edtKundennummer.MaxLength:=50;
  edtKundennummer.Text:='';
  edtKundennummer.ParentElement:=myelement;

  inc(i);
  myelement:=TC.cellelements[0,i];
  btnAnfordern:=TButton.Create(self);
  btnAnfordern.ElementClassName:='btn btn-info text-left';
  btnAnfordern.HeightStyle:=ssauto;
  btnAnfordern.WidthStyle:=ssauto;
  btnAnfordern.tag:=0;
  btnAnfordern.Caption:='Passwort anfordern';
  btnAnfordern.OnClick:=@btnAnfordernClick;
  btnAnfordern.ParentElement:=myelement;


end;

procedure TPasswortanforderung.xdsProtokollAfterPost(DataSet: TDataSet);
begin
  xdsProtokoll.ApplyUpdates;
end;

procedure TPasswortanforderung.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsAnmeldung := TXDataWebDataSet.Create(Self);
  xdsAnmeldungKundennummer := TStringField.Create(Self);
  xdsAnmeldungLoginPW := TStringField.Create(Self);
  xdsAnmeldungNachname := TStringField.Create(Self);
  xdsAnmeldungVorname := TStringField.Create(Self);
  xdsAnmeldungEMail := TStringField.Create(Self);
  xdsAnmeldungLoginAktiv := TIntegerField.Create(Self);
  WClient := TXDataWebClient.Create(Self);
  xdsProtokoll := TXDataWebDataSet.Create(Self);
  xdsProtokollID := TIntegerField.Create(Self);
  xdsProtokollDatum := TDateTimeField.Create(Self);
  xdsProtokollKundennummer := TStringField.Create(Self);
  xdsProtokollNotiz := TStringField.Create(Self);
  xdsProtokollPruefungErforderlich := TBooleanField.Create(Self);
  xdsProtokollPruefungErledigt := TDateTimeField.Create(Self);
  xdsProtokollPruefungErledigtDurch := TStringField.Create(Self);
  xdsProtokollBemerkung := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsAnmeldung.BeforeLoadDFMValues;
  xdsAnmeldungKundennummer.BeforeLoadDFMValues;
  xdsAnmeldungLoginPW.BeforeLoadDFMValues;
  xdsAnmeldungNachname.BeforeLoadDFMValues;
  xdsAnmeldungVorname.BeforeLoadDFMValues;
  xdsAnmeldungEMail.BeforeLoadDFMValues;
  xdsAnmeldungLoginAktiv.BeforeLoadDFMValues;
  WClient.BeforeLoadDFMValues;
  xdsProtokoll.BeforeLoadDFMValues;
  xdsProtokollID.BeforeLoadDFMValues;
  xdsProtokollDatum.BeforeLoadDFMValues;
  xdsProtokollKundennummer.BeforeLoadDFMValues;
  xdsProtokollNotiz.BeforeLoadDFMValues;
  xdsProtokollPruefungErforderlich.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigt.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigtDurch.BeforeLoadDFMValues;
  xdsProtokollBemerkung.BeforeLoadDFMValues;
  try
    Name := 'Passwortanforderung';
    Width := 279;
    Height := 456;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 279;
    TC.Height := 456;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsAnmeldung.SetParentComponent(Self);
    xdsAnmeldung.Name := 'xdsAnmeldung';
    xdsAnmeldung.AfterOpen := xdsAnmeldungAfterOpen;
    xdsAnmeldung.EntitySetName := 'Adressen';
    xdsAnmeldung.Connection := DM2.XDataWebConnection1;
    xdsAnmeldung.Left := 48;
    xdsAnmeldung.Top := 376;
    xdsAnmeldungKundennummer.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungKundennummer.Name := 'xdsAnmeldungKundennummer';
    xdsAnmeldungKundennummer.FieldName := 'Kundennummer';
    xdsAnmeldungKundennummer.Size := 13;
    xdsAnmeldungLoginPW.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungLoginPW.Name := 'xdsAnmeldungLoginPW';
    xdsAnmeldungLoginPW.FieldName := 'LoginPW';
    xdsAnmeldungNachname.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungNachname.Name := 'xdsAnmeldungNachname';
    xdsAnmeldungNachname.FieldName := 'Nachname';
    xdsAnmeldungNachname.Size := 40;
    xdsAnmeldungVorname.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungVorname.Name := 'xdsAnmeldungVorname';
    xdsAnmeldungVorname.FieldName := 'Vorname';
    xdsAnmeldungVorname.Size := 40;
    xdsAnmeldungEMail.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungEMail.Name := 'xdsAnmeldungEMail';
    xdsAnmeldungEMail.FieldName := 'EMail';
    xdsAnmeldungEMail.Size := 50;
    xdsAnmeldungLoginAktiv.SetParentComponent(xdsAnmeldung);
    xdsAnmeldungLoginAktiv.Name := 'xdsAnmeldungLoginAktiv';
    xdsAnmeldungLoginAktiv.FieldName := 'LoginAktiv';
    WClient.SetParentComponent(Self);
    WClient.Name := 'WClient';
    WClient.Connection := DM2.XDataWebConnection1;
    WClient.Left := 120;
    WClient.Top := 376;
    xdsProtokoll.SetParentComponent(Self);
    xdsProtokoll.Name := 'xdsProtokoll';
    xdsProtokoll.AfterApplyUpdates := xdsProtokollAfterApplyUpdates;
    xdsProtokoll.AfterOpen := xdsProtokollAfterOpen;
    xdsProtokoll.AfterPost := xdsProtokollAfterPost;
    xdsProtokoll.EntitySetName := 'KundenportalProtokoll';
    xdsProtokoll.Connection := DM2.XDataWebConnection1;
    xdsProtokoll.QueryTop := 1;
    xdsProtokoll.Left := 41;
    xdsProtokoll.Top := 192;
    xdsProtokollID.SetParentComponent(xdsProtokoll);
    xdsProtokollID.Name := 'xdsProtokollID';
    xdsProtokollID.FieldName := 'ID';
    xdsProtokollDatum.SetParentComponent(xdsProtokoll);
    xdsProtokollDatum.Name := 'xdsProtokollDatum';
    xdsProtokollDatum.FieldName := 'Datum';
    xdsProtokollKundennummer.SetParentComponent(xdsProtokoll);
    xdsProtokollKundennummer.Name := 'xdsProtokollKundennummer';
    xdsProtokollKundennummer.FieldName := 'Kundennummer';
    xdsProtokollKundennummer.Size := 13;
    xdsProtokollNotiz.SetParentComponent(xdsProtokoll);
    xdsProtokollNotiz.Name := 'xdsProtokollNotiz';
    xdsProtokollNotiz.FieldName := 'Notiz';
    xdsProtokollNotiz.Size := 250;
    xdsProtokollPruefungErforderlich.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErforderlich.Name := 'xdsProtokollPruefungErforderlich';
    xdsProtokollPruefungErforderlich.FieldName := 'PruefungErforderlich';
    xdsProtokollPruefungErledigt.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigt.Name := 'xdsProtokollPruefungErledigt';
    xdsProtokollPruefungErledigt.FieldName := 'PruefungErledigt';
    xdsProtokollPruefungErledigtDurch.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigtDurch.Name := 'xdsProtokollPruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.FieldName := 'PruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.Size := 50;
    xdsProtokollBemerkung.SetParentComponent(xdsProtokoll);
    xdsProtokollBemerkung.Name := 'xdsProtokollBemerkung';
    xdsProtokollBemerkung.FieldName := 'Bemerkung';
    xdsProtokollBemerkung.Size := 255;
  finally
    TC.AfterLoadDFMValues;
    xdsAnmeldung.AfterLoadDFMValues;
    xdsAnmeldungKundennummer.AfterLoadDFMValues;
    xdsAnmeldungLoginPW.AfterLoadDFMValues;
    xdsAnmeldungNachname.AfterLoadDFMValues;
    xdsAnmeldungVorname.AfterLoadDFMValues;
    xdsAnmeldungEMail.AfterLoadDFMValues;
    xdsAnmeldungLoginAktiv.AfterLoadDFMValues;
    WClient.AfterLoadDFMValues;
    xdsProtokoll.AfterLoadDFMValues;
    xdsProtokollID.AfterLoadDFMValues;
    xdsProtokollDatum.AfterLoadDFMValues;
    xdsProtokollKundennummer.AfterLoadDFMValues;
    xdsProtokollNotiz.AfterLoadDFMValues;
    xdsProtokollPruefungErforderlich.AfterLoadDFMValues;
    xdsProtokollPruefungErledigt.AfterLoadDFMValues;
    xdsProtokollPruefungErledigtDurch.AfterLoadDFMValues;
    xdsProtokollBemerkung.AfterLoadDFMValues;
  end;
end;

end.